import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

const Power = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#FC7361"
      d="M12 21.97c-5.19 0-9.41-4.22-9.41-9.41 0-3.45 1.89-6.62 4.92-8.27.41-.22.93-.07 1.15.34.22.41.07.93-.34 1.15a7.711 7.711 0 0 0-4.04 6.78c0 4.25 3.46 7.71 7.71 7.71s7.71-3.46 7.71-7.71a7.7 7.7 0 0 0-4.09-6.81.855.855 0 0 1-.35-1.15c.22-.41.74-.57 1.15-.35a9.39 9.39 0 0 1 4.99 8.31c0 5.19-4.22 9.41-9.41 9.41H12Z"
    />
    <Path
      fill="#FC7361"
      d="M12 12.73a.85.85 0 0 1-.85-.85V3a.85.85 0 1 1 1.7 0v8.88c0 .47-.38.85-.85.85Z"
    />
  </Svg>
)
export default Power
